import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/alert-dialog'
import { useTranslation } from 'react-i18next';

export default function SilentAudioConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  contentClassName = 'z-[60]',
}) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className={contentClassName}>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('reports.generate.silentAudio.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('reports.generate.silentAudio.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex sm:justify-start">
          <AlertDialogCancel className="w-full">
            {t('reports.generate.silentAudio.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction className="w-full" onClick={onConfirm}>
            {t('reports.generate.silentAudio.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
